import React, { useState } from 'react';
import { BookOpen, Award, Users, Sparkles } from 'lucide-react';
import { learnHubItems as mockLearnHubItems } from '../../data/mockData';
import OfferingCard from '../../components/OfferingCard';
import UlumEnroll from '../../components/UlumEnroll';

const LEARN_HERO_IMG = '/images/learn-hub-hero.jpeg';

const OTHER_WAYS = [
  { id: 'islamic-studies', label: 'Islamic Studies', icon: BookOpen },
  { id: 'skillsfuture', label: 'SkillsFuture Courses', icon: Award },
  { id: 'community-skills', label: 'Community Skills', icon: Users },
  { id: 'impact-learning', label: 'Impact & Growth', icon: Sparkles }
];

export default function LearnHub({ items, savedIds, onToggleSave, onSelectCourse, onExpressInterest }) {
  const learnHubItems = items || mockLearnHubItems;
  const [showAll, setShowAll] = useState(false);
  return (
    <div data-testid="learn-hub">
      <div className="p-4 desktop-shell md:pt-6">
        <div
          className="relative rounded-2xl overflow-hidden h-[150px] md:h-[220px]"
          data-testid="learn-hero"
          style={{ backgroundColor: '#0F9488' }}
        >
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-[55%] pl-5 md:pl-10 z-10">
              <h2 className="text-2xl md:text-3xl font-extrabold text-white leading-tight">Learn & Grow Together</h2>
              <p className="text-xs md:text-base text-white/80 mt-1.5 md:mt-2.5 leading-snug">Bite-sized courses for every stage of your journey.</p>
            </div>
            <img
              src={LEARN_HERO_IMG}
              alt=""
              className="absolute right-0 bottom-0 h-full w-[55%] object-cover object-bottom"
            />
          </div>
        </div>
      </div>

      <UlumEnroll />

      <div className="px-4 pb-2 desktop-shell" data-testid="learn-courses">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base md:text-lg font-bold text-[#0F172A]">Popular Courses</h2>
          <button
            type="button"
            data-testid="learn-see-all"
            onClick={() => setShowAll((v) => !v)}
            className="text-xs font-semibold text-primary"
          >
            {showAll ? 'Show Less' : 'See All'}
          </button>
        </div>
        <div className={`gap-3 md:gap-5 pb-1 ${
          showAll
            ? 'grid grid-cols-2 md:grid-cols-4'
            : 'flex md:grid md:grid-cols-4 overflow-x-auto scrollbar-hide'
        }`}>
          {learnHubItems.map((item) => (
            <div
              key={item.id}
              className={showAll ? 'w-full' : 'shrink-0 w-[132px] md:w-auto'}
            >
              <OfferingCard
                item={item}
                isSaved={savedIds.has(item.id)}
                onToggleSave={onToggleSave}
                onClick={() => onSelectCourse(item)}
                testId={`learn-card-${item.id}`}
                saveTestId={`learn-save-${item.id}`}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="px-4 pb-6 desktop-shell" data-testid="other-ways-to-learn">
        <h2 className="text-base md:text-lg font-bold text-[#0F172A] mb-3">Other Ways to Learn</h2>
        <div className="grid grid-cols-4 md:grid-cols-4 lg:w-2/3 gap-2 md:gap-4">
          {OTHER_WAYS.map((w) => {
            const Icon = w.icon;
            return (
              <button
                key={w.id}
                type="button"
                data-testid={`other-learn-way-${w.id}`}
                onClick={() => onExpressInterest?.(w.id, w.label)}
                className="flex flex-col items-center gap-1.5"
              >
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                  <Icon className="h-5 w-5 md:h-6 md:w-6" />
                </div>
                <span className="text-[10px] md:text-xs font-medium text-center leading-tight text-foreground">{w.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
